import { LIST_FIELD_FACETS } from 'api/ListsApi';
import { isEmptyString } from 'utils/stringHelpers';
import { useRestPostQuery } from 'utils/hooks/api';

import { useConditionState } from '../useConditionState';
import { FieldFacet } from '../../types';

export const useListFieldFacets = (enabled = true) => {
  const [{ field, dataType }] = useConditionState();
  const {
    isLoading,
    data: facets = [],
    error,
  } = useRestPostQuery<FieldFacet[]>(
    LIST_FIELD_FACETS,
    { field, dataType },
    {
      enabled: enabled && !isEmptyString(field),
      refetchOnWindowFocus: false,
    },
  );
  return { isLoading, facets, error };
};
